import { BodyParams, FieldProps, FormDataBase, FormWrapper } from "@/components/forms/common/FormBase";
import { username } from "@/components/forms/users/User";
import { SubmitHandler } from "react-hook-form";

export interface UserFormData extends FormDataBase {
  id?: string
  username: string
}

export const ManagerEditUserForm = (params: UsersFormParams) => {
  const formHandler: SubmitHandler<UserFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<UserFormData> {...params} formName='user' onSubmit={formHandler}>
    {ManagerEditUserBody(params)}
  </FormWrapper>
}

export const ManagerEditUserBody = (params: BodyParams<UserFormData>) => {
  const fieldProps: FieldProps<UserFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {username(fieldProps)}
  </>
}

export const ManagerInsertUserForm = (params: UsersFormParams) => {
  const formHandler: SubmitHandler<UserFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<UserFormData> {...params} formName='user' onSubmit={formHandler}>
    {ManagerInsertUserBody(params)}
  </FormWrapper>
}

export const ManagerInsertUserBody = (params: BodyParams<UserFormData>) => {
  const fieldProps: FieldProps<UserFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {username(fieldProps)}
  </>
}